import type { LeadStage } from "@school-sales-ai/shared";
import { usePipelineStagesQuery } from "@/hooks/usePipelineStages";
import { stageClasses, stageLabel } from "@/lib/stage-config";

type Props = { stage: LeadStage; small?: boolean };

export function StagePill({ stage, small = false }: Props): React.JSX.Element {
  const { data: stages } = usePipelineStagesQuery();
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium whitespace-nowrap ${stageClasses(stage, stages)} ${small ? "text-[10px]" : "text-[11px]"}`}
      style={{ padding: small ? "2px 7px" : "3px 9px" }}
    >
      {stageLabel(stage, stages)}
    </span>
  );
}
